import { toRefs } from "vue";
import { useCartStore } from "~/stores/cart";
import { useOrderStore } from "~/stores/order";
import type { Patient } from "~/types/order-processing";

export const useOrderPayload = () => {
  const cartStore = useCartStore();
  const orderStore = useOrderStore();

  const prepareOrderPayload = () => {
    const { cartItems } = toRefs(cartStore);
    const { patientsCollection } = toRefs(orderStore);

    if (patientsCollection.value.recipients.length === 0) {
      return null;
    }

    const parentUser = patientsCollection.value.recipients[0];
    const recipientsPayload = patientsCollection.value.recipients.slice(1).map((recipient: Patient) => ({
      first_name: recipient.first_name,
      last_name: recipient.last_name,
      date_of_birth: recipient.date_of_birth,
      gender: recipient.gender,
      email: recipient.email,
      telephone_number: recipient.telephone_number,
      same_delivery_address: recipient.same_address ? "1" : "0",
      test_id: (recipient.tests || []).map((test: string) => test && test.split("_")[0]),
      shipping_method_id: recipient.shipping_method?.id || "",
      ...(!recipient.same_address && {
        home_address: recipient.address_line_1,
        home_address_line_2: recipient.address_line_2,
        home_city: recipient.city,
        home_state: recipient.state,
        home_country: recipient.country,
        home_postcode: recipient.postcode,
      }),
    }));

    const payload = {
      order_for:
        patientsCollection.value.orderForMultipleUser && patientsCollection.value.recipients.length > 1
          ? "multiple"
          : "self",
      // test_id: cartItems.value.map((item) => item.id),
      test_id: cartItems.value.map((item) => item.id),
      quantity: cartItems.value.map((item) => item.quantity),
      first_name: parentUser.first_name,
      last_name: parentUser.last_name,
      date_of_birth: parentUser.date_of_birth,
      gender: parentUser.gender,
      email: parentUser.email,
      telephone_number: parentUser.telephone_number,
      home_address: parentUser.address_line_1,
      home_address_line_2: parentUser.address_line_2,
      home_city: parentUser.city,
      home_state: parentUser.state,
      home_country: parentUser.country,
      home_postcode: parentUser.postcode,
      start_point: "get-started",
      shipping_method_id: parentUser.shipping_method?.id || "",
      ...(recipientsPayload.length > 0 && {
        recipients: recipientsPayload,
      }),
    };

    return payload;
  };

  return {
    prepareOrderPayload,
  };
};
